export default "__VITE_ASSET__BbvzXAj8__"